import { Button } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import Select from "react-select";
import useEstimateForm from "./useEstimateForm";

const EstimateForm = ({handleClose, handleCertificatePrint}) => {
  const {
    formik,
    estimateTypes,
    handleItemChange,
    handleCancel,
  } = useEstimateForm();

  const handelOnclick = () => {
    if (formik?.values?.estimate_type?._id) {
      handleCertificatePrint(formik?.values?.estimate_type?._id);
    }else{
      formik?.submitForm();
    }
  };


  return (
    <div className="col pro-p-4 ">
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Estimate Type
        </label>
        <Select
          id="estimate_type"
          placeholder={"Select"}
          className={`pro-input lg ${
            formik?.errors?.estimate_type && formik?.touched?.estimate_type && "error"
          } `}
          classNamePrefix="pro-input"
          isMulti={false}
          name="estimate_type"
          options={estimateTypes}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={formik?.values?.estimate_type}
          onChange={handleItemChange}
          menuPlacement="auto"
          onBlur={formik?.handleBlur("estimate_type")}
        />
        {formik?.errors?.estimate_type && formik?.touched?.estimate_type && (
          <span className="error-text">{formik.errors?.estimate_type}</span>
        )}
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end  offcanvas-footer-sticky-btn `}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={handelOnclick}
          disabled={formik?.isSubmitting}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default EstimateForm;
